/**
 * A volta da Meta depois do consentimento do Facebook e do Instagram
 * (29/09/2026).
 *
 * A Meta devolve a pessoa para `META_REDIRECT_URI` — no staging,
 * `/integracoes/meta/retorno?code=…&state=…` — e a interface não tem rota por
 * endereço: quem decide a tela é o estado. Então este arquivo lê o endereço
 * UMA vez, na carga, e a casca abre Configurações → Conexões quando há
 * retorno; o assistente de canal segue dali, listando as páginas.
 *
 * O endereço é limpo na hora da leitura. O `code` é de uso único, e
 * recarregar a página com ele na barra o mandaria de novo à Meta, que o
 * recusaria com um erro que não diz nada a quem vê.
 */

import type { TipoDeCanal } from '@cliqcrm/contracts';

export const CAMINHO_DO_RETORNO_DA_META = '/integracoes/meta/retorno';

/** Qual cartão da grade levou à Meta: o texto e a lista mudam com ele. */
export type CanalDaMeta = Extract<TipoDeCanal, 'facebook' | 'instagram'>;

export type RetornoDaMeta =
  | { tipo: 'codigo'; code: string; state: string; canal: CanalDaMeta }
  | { tipo: 'cancelado'; canal: CanalDaMeta };

const CHAVE_DO_CANAL = 'cliqcrm:canal-da-meta';

let lido: RetornoDaMeta | null | undefined;

/** Guarda qual canal a pessoa escolheu, antes de sair para a Meta. */
export function lembrarCanalDaMeta(canal: CanalDaMeta): void {
  try {
    sessionStorage.setItem(CHAVE_DO_CANAL, canal);
  } catch {
    // Sem armazenamento, a volta assume Facebook: a lista é a mesma.
  }
}

function canalLembrado(): CanalDaMeta {
  try {
    return sessionStorage.getItem(CHAVE_DO_CANAL) === 'instagram' ? 'instagram' : 'facebook';
  } catch {
    return 'facebook';
  }
}

/** O retorno desta carga, ou nulo. Lê e limpa o endereço na primeira chamada. */
export function retornoDaMeta(): RetornoDaMeta | null {
  if (lido !== undefined) return lido;
  lido = null;
  if (typeof location === 'undefined' || location.pathname !== CAMINHO_DO_RETORNO_DA_META) {
    return lido;
  }

  const busca = new URLSearchParams(location.search);
  const code = busca.get('code');
  const state = busca.get('state');
  const canal = canalLembrado();
  lido = code && state ? { tipo: 'codigo', code, state, canal } : { tipo: 'cancelado', canal };

  history.replaceState(null, '', '/');
  return lido;
}

/** Entrega o retorno a quem vai usá-lo, uma vez só. */
export function consumirRetornoDaMeta(): RetornoDaMeta | null {
  const retorno = retornoDaMeta();
  lido = null;
  return retorno;
}
